import { ChangeEvent, FC } from 'react';
import { format } from 'date-fns';
import { PickerInput } from '~/components';
import { PickerInputTypeEnum } from '~/components/PickerInput';
import { DATE_FORMAT } from '~/utils';
import { useTableFilters } from '../context';
import { FilterComponentProps } from './types';

const DateFilter: FC<FilterComponentProps> = ({ filterId }) => {
  const { selectedFilters: allSelectedFilters, changeFilters } = useTableFilters();
  const selectedFilters = allSelectedFilters[filterId];

  const handleDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    const date = event.target.value;
    changeFilters(filterId, date === '' ? [] : [{ id: date, label: format(new Date(date), DATE_FORMAT) }]);
  };

  return (
    <PickerInput
      value={selectedFilters?.[0]?.id}
      onChange={handleDateChange}
      placeholder={selectedFilters?.[0]?.id}
      label=""
      type={PickerInputTypeEnum.DATE}
    />
  );
};

export default DateFilter;
